/* DivisionBridge — one-line "Explore other divisions" row.
 *
 * Rendered just above the compliance strip in each division footer
 * (Systems / Services / Academy). Shows the OTHER two divisions as
 * small outlined chips with their logos so visitors landing on one
 * division still have a discoverability bridge to the rest of the
 * business without polluting the in-division link columns above.
 *
 * Usage: <DivisionBridge current="services" />
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Wrench, ShoppingBag, GraduationCap } from 'lucide-react';

const DIVISIONS = {
  systems:  { to: '/systems',  label: 'ZHELTA Systems',  tagline: 'Enterprise IT & deployment',   Icon: Wrench },
  services: { to: '/services', label: 'ZHELTA Services', tagline: 'Verified hardware & gear',     Icon: ShoppingBag },
  academy:  { to: '/academy',  label: 'ZHELTA Academy',  tagline: 'Practical IT education',       Icon: GraduationCap },
};

export default function DivisionBridge({ current }) {
  const others = Object.entries(DIVISIONS).filter(([key]) => key !== current);

  return (
    <section
      className="border-t border-zinc-200"
      data-testid={`division-bridge-${current}`}
    >
      <div className="max-w-[1200px] mx-auto px-4 lg:px-6 py-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <span className="text-[10px] tracking-[0.22em] uppercase font-bold text-zinc-500 shrink-0">
          Explore other divisions
        </span>
        <div className="flex flex-wrap gap-2">
          {others.map(([key, d]) => {
            const Icon = d.Icon;
            return (
              <Link
                key={key}
                to={d.to}
                data-testid={`division-bridge-chip-${key}`}
                className="group inline-flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-full border border-zinc-300 hover:border-[#c9a227] hover:bg-white transition-colors text-zinc-900"
              >
                <span className="w-5 h-5 rounded-full bg-[#f5a623]/15 grid place-items-center text-[#c9a227]">
                  <Icon className="w-3 h-3" />
                </span>
                <span className="text-[12px] font-bold">{d.label}</span>
                <span className="text-[11px] text-zinc-500 hidden md:inline">{d.tagline}</span>
                <ArrowUpRight className="w-3 h-3 text-zinc-500 group-hover:text-[#c9a227] transition-colors" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
